var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGrupo74(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 453.737,
    height: 68,
    viewBox: "0 0 453.737 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_74",
    "data-name": "Grupo 74",
    transform: "translate(-29.75 -551.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_68",
    "data-name": "Grupo 68",
    transform: "translate(29.75 551.75)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_67",
    "data-name": "Grupo 67"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_99",
    "data-name": "Trazado 99",
    d: "M483.487,551.75,381.459,619.7v.05H29.75v-.3L131.4,551.75Z",
    transform: "translate(-29.75 -551.75)",
    fill: "#333"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo74);
export default __webpack_public_path__ + "static/media/Grupo 74.a973a6da55843fe2d2f9e09b7f9db771.svg";
export { ForwardRef as ReactComponent };